import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchMeta = () => api.get("/boq/meta").then(r => r.data);
export const fetchItems = () => api.get("/boq/items").then(r => r.data);
export const fetchScenarios = () => api.get("/scenarios").then(r => r.data);
export const fetchScenario = (id) => api.get(`/scenarios/${id}`).then(r => r.data);
export const createScenario = (body) => api.post("/scenarios", body).then(r => r.data);
export const updateScenario = (id, body) => api.patch(`/scenarios/${id}`, body).then(r => r.data);
export const deleteScenario = (id) => api.delete(`/scenarios/${id}`).then(r => r.data);
export const resetScenario = (id) => api.post(`/scenarios/${id}/reset`).then(r => r.data);
export const updateItemEdit = (sid, iid, body) => api.patch(`/scenarios/${sid}/items/${iid}`, body).then(r => r.data);
export const bulkToggle = (sid, body) => api.post(`/scenarios/${sid}/bulk-toggle`, body).then(r => r.data);
export const exportExcelURL = (sid) => `${API}/scenarios/${sid}/export/excel`;
export const exportPdfURL = (sid) => `${API}/scenarios/${sid}/export/pdf`;

// Benchmarks (AI market rate)
export const fetchBenchmarks = () => api.get("/benchmarks").then(r => r.data);
export const analyzeItem = (itemId) => api.post(`/benchmarks/analyze/${itemId}`).then(r => r.data);
export const analyzeAll = (force = false) => api.post("/benchmarks/analyze-all", { force }).then(r => r.data);
export const clearBenchmarks = () => api.delete("/benchmarks").then(r => r.data);
export const createScenarioFromBenchmarks = (body) => api.post("/scenarios/from-benchmarks", body).then(r => r.data);

// Vendor report
export const fetchVendorReport = (sid) => api.get(`/scenarios/${sid}/vendor-report`).then(r => r.data);
export const generateVendorReport = (sid, body) => api.post(`/scenarios/${sid}/vendor-report`, body).then(r => r.data);
export const vendorReportPdfURL = (sid) => `${API}/scenarios/${sid}/vendor-report/pdf`;
